module.exports = __webpack_public_path__ + "assets/img/kncb.32e9118e.png";